module.exports = __webpack_public_path__ + "img/20e10cf.png";